var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelsLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 578.627,
    height: 500.398,
    viewBox: "0 0 578.627 500.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2045",
    x: 38.333,
    y: 0,
    width: 377,
    height: 492.808,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#949494",
    floodOpacity: 0.259
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_83124",
    x: 0,
    y: 141.275,
    width: 321.333,
    height: 250.021,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#dce1e9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2151",
    x: 9.831,
    y: 268.195,
    width: 297.791,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5600ff",
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.596,
    y1: 0.5,
    x2: 1.162,
    y2: -0.385,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1450ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a2880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_15",
    x: 280.333,
    y: 282.398,
    width: 283,
    height: 218,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#dce1e9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2151-2",
    x: 344.761,
    y: 380.891,
    width: 156.795,
    height: 96.888,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5600ff",
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_140435",
    x: 237.627,
    y: 56.398,
    width: 341,
    height: 179,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#474646",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1",
    x: 441.127,
    y: 97.898,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1450ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161021",
    "data-name": "Group 161021",
    transform: "translate(-162.873 -430.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160386",
    "data-name": "Group 160386",
    transform: "translate(-701.294 180.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161016",
    "data-name": "Group 161016",
    transform: "translate(6896 19266.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M1967,8621a17,17,0,1,1,12.021-4.979A16.888,16.888,0,0,1,1967,8621Zm5.623-24.142h3.9l-5.615,7.646a3.833,3.833,0,0,1-1.286,1.146,3.17,3.17,0,0,1,.9.5,3.836,3.836,0,0,1,.753.845l5.539,8.49h2.44l-.018-22.54h-23.282v22.54h4.111v-18.627h4.369v7.668h.7c.049,0,.1.007.15.007a1.6,1.6,0,0,0,1.254-.614l4.264-6.192a2.147,2.147,0,0,1,.813-.686A2.754,2.754,0,0,1,1972.622,8596.858Zm-8.192,10.872v7.76h7.372a.968.968,0,0,1-.176-.151,1.935,1.935,0,0,1-.278-.347l-4.286-6.586a1.324,1.324,0,0,0-.593-.526,2.543,2.543,0,0,0-.872-.152c-.032,0-.064,0-.1,0Z",
    transform: "translate(-7871 -27563.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161008",
    "data-name": "Group 161008",
    transform: "translate(-6891 -19232.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160887",
    "data-name": "Group 160887",
    transform: "translate(950 256)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -90.83, -40.5)",
    filter: "url(#Rectangle_2045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2045-2",
    "data-name": "Rectangle 2045",
    d: "M0,0H272a0,0,0,0,1,0,0V381.808a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V0A0,0,0,0,1,0,0Z",
    transform: "translate(90.83 40.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    width: 272,
    height: 292,
    transform: "translate(-5941 -18920.742)",
    fill: "#f5f6f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161014",
    "data-name": "Group 161014",
    transform: "translate(-6852.207 -19293.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160702",
    "data-name": "Group 160702",
    transform: "translate(-71 3.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160573",
    "data-name": "Group 160573"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Powered_by_Falkon_Systems_Falkon_SMS",
    "data-name": "Powered by Falkon Systems & Falkon SMS",
    transform: "translate(1052 684)",
    fill: "#818792",
    fontSize: 7,
    fontFamily: "Silka-Medium, Silka",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered by Falkon Systems &amp; Falkon SMS")), /*#__PURE__*/React.createElement("g", {
    id: "Falkon_SYSTEMS-01",
    "data-name": "Falkon SYSTEMS-01",
    transform: "translate(1038.413 673.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M177.154,216.241a11.283,11.283,0,0,1-2.342-3.841,5.153,5.153,0,0,0-.379,1.419c-.038.453-.234,1.814,1.793,3.713,1.391,1.3,1.946,2.233,1.967,3.436-.413-2.252-3.809-3.407-4.027-5.134a5.6,5.6,0,0,0,2.479,5.562c2.3,1.816-.407,5.168-2.5,6.82,2.7-1.623,4.043-3.1,4.806-5.18A6.108,6.108,0,0,0,177.154,216.241Z",
    transform: "translate(-174.125 -212.4)",
    fill: "#647084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M586.9,603.67c-.862-.312-1.432.164-2.2.462a6.07,6.07,0,0,1-.1,6.052,7.558,7.558,0,0,1-1.1,1.781h0c1.8-1.621,2.745-4.931,2.745-4.931l.031-.13c.672-2.576,1.885-1.756,1.886-1.756A2.176,2.176,0,0,0,586.9,603.67Z",
    transform: "translate(-579.989 -598.997)",
    fill: "#647084"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6031.83, -19017.24)",
    filter: "url(#Path_83124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83124-2",
    "data-name": "Path 83124",
    d: "M10.659,0H235.675a10.841,10.841,0,0,1,10.659,11.015v159.11a4.818,4.818,0,0,1-4.737,4.9H10.659A10.841,10.841,0,0,1,0,164.006V11.015A10.841,10.841,0,0,1,10.659,0Z",
    transform: "translate(37.5 166.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161015",
    "data-name": "Group 161015",
    transform: "translate(-67.934 -12.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160898",
    "data-name": "Group 160898",
    transform: "translate(-5916.568 -18710.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -47.33, -293.7)",
    filter: "url(#Rectangle_2151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151-3",
    "data-name": "Rectangle 2151",
    width: 222.791,
    height: 30,
    rx: 5,
    transform: "translate(47.33 293.7)",
    fill: "#1450ff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Login",
    transform: "translate(110.575 18.553)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11,
    y: 0
  }, "Login"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160922",
    "data-name": "Group 160922",
    transform: "translate(-6891 -19226.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2077",
    "data-name": "Rectangle 2077",
    transform: "translate(974.778 416.4)",
    fill: "#fff",
    stroke: "#e9e9e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.791,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 221.791,
    height: 29,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "First_and_last_name",
    "data-name": "First and last name",
    transform: "translate(985.8 423.074)",
    fill: "#a0a0a0",
    fontSize: 10,
    fontFamily: "SegoeUI-Semilight, Segoe UI",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "First and last name")), /*#__PURE__*/React.createElement("text", {
    id: "Name_",
    "data-name": "Name *",
    transform: "translate(976.298 409.578)",
    fill: "#3e5172",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Name *"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160923",
    "data-name": "Group 160923",
    transform: "translate(-6891 -19226.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    transform: "translate(974.778 470)",
    fill: "#fff",
    stroke: "#e9e9e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.791,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 221.791,
    height: 29,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "email_example.com",
    "data-name": "email@example.com",
    transform: "translate(985.8 477.148)",
    fill: "#a0a0a0",
    fontSize: 10,
    fontFamily: "SegoeUI-Semilight, Segoe UI",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "email@example.com")), /*#__PURE__*/React.createElement("text", {
    id: "Email_",
    "data-name": "Email *",
    transform: "translate(975.348 463.434)",
    fill: "#3e5172",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email *")))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    d: "M6,0H266a6,6,0,0,1,6,6V96a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    transform: "translate(-5941 -18990.742)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Testing_Channel",
    "data-name": "Testing Channel",
    transform: "translate(-5877 -18956.742)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Testing Channel")), /*#__PURE__*/React.createElement("text", {
    id: "Online",
    transform: "translate(-5864 -18941.742)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Online")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-5875 -18947.742)",
    fill: "#08c608"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Connect_with",
    "data-name": "Connect with",
    transform: "translate(971.516 346.586)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Connect with")), /*#__PURE__*/React.createElement("g", {
    id: "Group_161017",
    "data-name": "Group 161017",
    transform: "translate(-150.971 -70.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M155.713,106.005l.346-2.254H153.9v-1.463a1.127,1.127,0,0,1,1.271-1.218h.983V99.154A11.872,11.872,0,0,0,154.4,99a2.751,2.751,0,0,0-2.945,3.034v1.718H149.48v2.254h1.98v5.448a7.88,7.88,0,0,0,2.437,0v-5.448Z",
    transform: "translate(1033.904 317.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M19.025,9.865A6.376,6.376,0,0,0,14.485,8a6.454,6.454,0,0,0-5.594,9.728L8,20.971l3.4-.892a6.98,6.98,0,0,0,3.081.811,6.421,6.421,0,0,0,4.54-11.025Zm-4.54,9.971a5.391,5.391,0,0,1-2.756-.73l-.162-.081-2.027.567.567-1.946L9.946,17.4a5.216,5.216,0,0,1-.811-2.837,5.4,5.4,0,0,1,5.35-5.35,5.54,5.54,0,0,1,3.81,1.54,5.2,5.2,0,0,1,1.54,3.81A5.329,5.329,0,0,1,14.485,19.836ZM17.4,15.782a6.832,6.832,0,0,0-1.135-.486c-.162-.081-.243-.081-.324.081s-.405.486-.486.649c-.081.081-.162.081-.324.081a4.533,4.533,0,0,1-1.3-.811,3.94,3.94,0,0,1-.892-1.135c-.081-.162,0-.243.081-.324l.243-.243c.081-.081.081-.162.162-.243s0-.162,0-.243a9.251,9.251,0,0,0-.486-1.216.3.3,0,0,0-.324-.243H12.3a.524.524,0,0,0-.405.162,1.815,1.815,0,0,0-.567,1.378,3.468,3.468,0,0,0,.649,1.7,6.983,6.983,0,0,0,2.756,2.432,3.233,3.233,0,0,0,1.946.405A1.428,1.428,0,0,0,17.728,17c.162-.405.162-.73.081-.73A.524.524,0,0,0,17.4,15.782Z",
    transform: "translate(1199.053 408.529)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram-svgrepo-com",
    transform: "translate(1234.332 416.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83111",
    "data-name": "Path 83111",
    d: "M9.516,13.032A3.516,3.516,0,1,0,6,9.516,3.516,3.516,0,0,0,9.516,13.032Zm0-1.172A2.344,2.344,0,1,0,7.172,9.516,2.344,2.344,0,0,0,9.516,11.86Z",
    transform: "translate(-3.07 -3.07)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83112",
    "data-name": "Path 83112",
    d: "M17.586,5a.586.586,0,1,0,.586.586A.586.586,0,0,0,17.586,5Z",
    transform: "translate(-7.624 -2.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83113",
    "data-name": "Path 83113",
    d: "M1.383,2.92C1,3.672,1,4.657,1,6.626V8.267c0,1.969,0,2.954.383,3.706A3.516,3.516,0,0,0,2.92,13.509c.752.383,1.737.383,3.706.383H8.267c1.969,0,2.954,0,3.706-.383a3.516,3.516,0,0,0,1.537-1.537c.383-.752.383-1.737.383-3.706V6.626c0-1.969,0-2.954-.383-3.706a3.516,3.516,0,0,0-1.537-1.537C11.22,1,10.236,1,8.267,1H6.626C4.657,1,3.672,1,2.92,1.383A3.516,3.516,0,0,0,1.383,2.92Zm6.883-.748H6.626c-1,0-1.686,0-2.214.044a2.53,2.53,0,0,0-.96.211A2.344,2.344,0,0,0,2.428,3.452a2.53,2.53,0,0,0-.211.96c-.043.528-.044,1.21-.044,2.214V8.267c0,1,0,1.686.044,2.214a2.53,2.53,0,0,0,.211.96,2.344,2.344,0,0,0,1.024,1.024,2.529,2.529,0,0,0,.96.211c.528.043,1.21.044,2.214.044H8.267c1,0,1.686,0,2.214-.044a2.529,2.529,0,0,0,.96-.211,2.344,2.344,0,0,0,1.024-1.024,2.529,2.529,0,0,0,.211-.96c.043-.528.044-1.21.044-2.214V6.626c0-1,0-1.686-.044-2.214a2.529,2.529,0,0,0-.211-.96A2.344,2.344,0,0,0,11.44,2.428a2.53,2.53,0,0,0-.96-.211C9.953,2.173,9.27,2.172,8.267,2.172Z",
    transform: "translate(-1 -1)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_161018",
    "data-name": "Group 161018",
    transform: "translate(435.706 388)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -272.83, 42.1)",
    filter: "url(#Rectangle_15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    d: "M9,0H199a9,9,0,0,1,9,9V139a4,4,0,0,1-4,4H9a9,9,0,0,1-9-9V9A9,9,0,0,1,9,0Z",
    transform: "translate(317.83 307.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "How_do_you_want_to_rate_our_service_",
    "data-name": "How do you want to rate our service?",
    transform: "translate(95 371)",
    fill: "#0d0d0d",
    fontSize: 11,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 12
  }, "How do you want to "), /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 26
  }, "rate our service?")), /*#__PURE__*/React.createElement("g", {
    id: "Group_160970",
    "data-name": "Group 160970",
    transform: "translate(109.428 448.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -382.26, -406.39)",
    filter: "url(#Rectangle_2151-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151-4",
    "data-name": "Rectangle 2151",
    width: 81.795,
    height: 21.888,
    rx: 5,
    transform: "translate(382.26 406.39)",
    fill: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Submit",
    transform: "translate(41.192 12.276)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "Submit"))), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com",
    d: "M7.9,4.811C8.943,2.937,9.465,2,10.246,2s1.3.937,2.347,2.811l.27.485a3.025,3.025,0,0,0,.677.974,2.818,2.818,0,0,0,1.1.371l.525.119c2.028.459,3.042.688,3.284,1.464s-.45,1.584-1.833,3.2l-.358.418a3.035,3.035,0,0,0-.678.973,3.168,3.168,0,0,0,0,1.2l.054.558c.209,2.157.314,3.236-.318,3.715s-1.581.042-3.48-.832l-.491-.226a2.813,2.813,0,0,0-1.1-.373,2.813,2.813,0,0,0-1.1.373l-.491.226c-1.9.874-2.849,1.312-3.48.832s-.527-1.558-.318-3.715l.054-.558a3.165,3.165,0,0,0,0-1.2,3.035,3.035,0,0,0-.678-.973l-.358-.418C2.5,9.808,1.806,9,2.047,8.224S3.3,7.219,5.331,6.76l.525-.119a2.819,2.819,0,0,0,1.1-.371A3.025,3.025,0,0,0,7.628,5.3Z",
    transform: "translate(76.316 414.5)",
    fill: "#ffae0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com-2",
    "data-name": "star-svgrepo-com",
    d: "M7.9,4.811C8.943,2.937,9.465,2,10.246,2s1.3.937,2.347,2.811l.27.485a3.025,3.025,0,0,0,.677.974,2.818,2.818,0,0,0,1.1.371l.525.119c2.028.459,3.042.688,3.284,1.464s-.45,1.584-1.833,3.2l-.358.418a3.035,3.035,0,0,0-.678.973,3.168,3.168,0,0,0,0,1.2l.054.558c.209,2.157.314,3.236-.318,3.715s-1.581.042-3.48-.832l-.491-.226a2.813,2.813,0,0,0-1.1-.373,2.813,2.813,0,0,0-1.1.373l-.491.226c-1.9.874-2.849,1.312-3.48.832s-.527-1.558-.318-3.715l.054-.558a3.165,3.165,0,0,0,0-1.2,3.035,3.035,0,0,0-.678-.973l-.358-.418C2.5,9.808,1.806,9,2.047,8.224S3.3,7.219,5.331,6.76l.525-.119a2.819,2.819,0,0,0,1.1-.371A3.025,3.025,0,0,0,7.628,5.3Z",
    transform: "translate(108.793 414.5)",
    fill: "#ffae0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com-3",
    "data-name": "star-svgrepo-com",
    d: "M7.9,4.811C8.943,2.937,9.465,2,10.246,2s1.3.937,2.347,2.811l.27.485a3.025,3.025,0,0,0,.677.974,2.818,2.818,0,0,0,1.1.371l.525.119c2.028.459,3.042.688,3.284,1.464s-.45,1.584-1.833,3.2l-.358.418a3.035,3.035,0,0,0-.678.973,3.168,3.168,0,0,0,0,1.2l.054.558c.209,2.157.314,3.236-.318,3.715s-1.581.042-3.48-.832l-.491-.226a2.813,2.813,0,0,0-1.1-.373,2.813,2.813,0,0,0-1.1.373l-.491.226c-1.9.874-2.849,1.312-3.48.832s-.527-1.558-.318-3.715l.054-.558a3.165,3.165,0,0,0,0-1.2,3.035,3.035,0,0,0-.678-.973l-.358-.418C2.5,9.808,1.806,9,2.047,8.224S3.3,7.219,5.331,6.76l.525-.119a2.819,2.819,0,0,0,1.1-.371A3.025,3.025,0,0,0,7.628,5.3Z",
    transform: "translate(140.254 414.5)",
    fill: "#dedfe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com-4",
    "data-name": "star-svgrepo-com",
    d: "M7.9,4.811C8.943,2.937,9.465,2,10.246,2s1.3.937,2.347,2.811l.27.485a3.025,3.025,0,0,0,.677.974,2.818,2.818,0,0,0,1.1.371l.525.119c2.028.459,3.042.688,3.284,1.464s-.45,1.584-1.833,3.2l-.358.418a3.035,3.035,0,0,0-.678.973,3.168,3.168,0,0,0,0,1.2l.054.558c.209,2.157.314,3.236-.318,3.715s-1.581.042-3.48-.832l-.491-.226a2.813,2.813,0,0,0-1.1-.373,2.813,2.813,0,0,0-1.1.373l-.491.226c-1.9.874-2.849,1.312-3.48.832s-.527-1.558-.318-3.715l.054-.558a3.165,3.165,0,0,0,0-1.2,3.035,3.035,0,0,0-.678-.973l-.358-.418C2.5,9.808,1.806,9,2.047,8.224S3.3,7.219,5.331,6.76l.525-.119a2.819,2.819,0,0,0,1.1-.371A3.025,3.025,0,0,0,7.628,5.3Z",
    transform: "translate(172.731 414.5)",
    fill: "#dedfe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com-5",
    "data-name": "star-svgrepo-com",
    d: "M7.9,4.811C8.943,2.937,9.465,2,10.246,2s1.3.937,2.347,2.811l.27.485a3.025,3.025,0,0,0,.677.974,2.818,2.818,0,0,0,1.1.371l.525.119c2.028.459,3.042.688,3.284,1.464s-.45,1.584-1.833,3.2l-.358.418a3.035,3.035,0,0,0-.678.973,3.168,3.168,0,0,0,0,1.2l.054.558c.209,2.157.314,3.236-.318,3.715s-1.581.042-3.48-.832l-.491-.226a2.813,2.813,0,0,0-1.1-.373,2.813,2.813,0,0,0-1.1.373l-.491.226c-1.9.874-2.849,1.312-3.48.832s-.527-1.558-.318-3.715l.054-.558a3.165,3.165,0,0,0,0-1.2,3.035,3.035,0,0,0-.678-.973l-.358-.418C2.5,9.808,1.806,9,2.047,8.224S3.3,7.219,5.331,6.76l.525-.119a2.819,2.819,0,0,0,1.1-.371A3.025,3.025,0,0,0,7.628,5.3Z",
    transform: "translate(204.192 414.5)",
    fill: "#dedfe1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161020",
    "data-name": "Group 161020"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 162.87, 430.1)",
    filter: "url(#Rectangle_140435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140435-2",
    "data-name": "Rectangle 140435",
    width: 236,
    height: 74,
    rx: 37,
    transform: "translate(290.13 96.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161019",
    "data-name": "Group 161019",
    transform: "translate(627.672 539.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422",
    transform: "translate(0.328 0.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465.13, -109.9)",
    filter: "url(#Ellipse_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(465.13 109.9)",
    fill: "#1450ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "chatbubble-ellipses",
    d: "M51.628,34.673A12.2,12.2,0,0,0,44,32a12.055,12.055,0,0,0-8.6,3.544,11.6,11.6,0,0,0-1.492,14.589l.01.015.046.065.039.056.012.021a.47.47,0,0,1,.066.37L33.1,54.237a1.562,1.562,0,0,0-.064.409,1.378,1.378,0,0,0,1.371,1.38,1.579,1.579,0,0,0,.56-.123l3.62-1.306.046-.018a.791.791,0,0,1,.311-.062.811.811,0,0,1,.288.054c.087.034.876.336,1.708.568a14.126,14.126,0,0,0,3.259.483,11.794,11.794,0,0,0,11.83-11.851,11.449,11.449,0,0,0-.256-2.413A11.764,11.764,0,0,0,51.628,34.673ZM34.974,50.663Zm3.889-4.934a1.716,1.716,0,1,1,1.716-1.716A1.716,1.716,0,0,1,38.864,45.729Zm5.149,0a1.716,1.716,0,1,1,1.716-1.716A1.716,1.716,0,0,1,44.012,45.729Zm5.149,0a1.716,1.716,0,1,1,1.716-1.716A1.716,1.716,0,0,1,49.161,45.729Z",
    transform: "translate(-21.1 -21.231)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\uD83D\\uDC4B",
    transform: "translate(469 546)",
    fill: "#6e6e6e",
    fontSize: 23,
    fontFamily: "SegoeUIEmoji, Segoe UI Emoji"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25
  }, "\uD83D\uDC4B")), /*#__PURE__*/React.createElement("text", {
    id: "Need_help_",
    "data-name": "Need help?",
    transform: "translate(513 538)",
    fill: "#6e6e6e",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Need help?")), /*#__PURE__*/React.createElement("text", {
    id: "Click_here_and_start_chatting_with_us_",
    "data-name": "Click here and start chatting with us ",
    transform: "translate(513 558)",
    fill: "#6e6e6e",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Click here and start "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "chatting with us "))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsLoginIcon);
export default __webpack_public_path__ + "static/media/channels-login-icon.2bcf36d3caca9f686d40ab680590ab02.svg";
export { ForwardRef as ReactComponent };